export interface DrillDownMenuItem {
  name: string;
  isCategory: boolean;
  subItems: DrillDownMenuItem[];
  isPremium: boolean;
  disable: boolean;
  action?: string;
  extra?: any;
  icon?: string;
  isSelected?: boolean;
  counter?: number;
  isList?: boolean;
  borderTop?: boolean;
  premiumKey?: string;
}

export interface DrillDownMenuConfig {
  menu: DrillDownMenuItem[];
  side?: "left" | "right";
  cmp?: any;
  event: MouseEvent;
}

interface DrillDownMenuSuccessResponse {
  didUserSelectedAnAction: true;
  actionSelected: string;
}

interface DrillDownMenuCanceledResponse {
  didUserSelectedAnAction: false;
}

export type DrillDownMenuResponse =
  | DrillDownMenuSuccessResponse
  | DrillDownMenuCanceledResponse;

export const DrillDownMenuHelper = {
  simple: (name: string, icon: string, action: string): DrillDownMenuItem => {
    return {
      disable: false,
      isCategory: false,
      isPremium: false,
      name,
      subItems: [],
      action,
      icon,
    };
  },
};

export const UseDrillDownMenu = (() => {
  let last_trigger_id = "";
  let listener: (d: DrillDownMenuConfig) => Promise<DrillDownMenuResponse>;

  function listenForDrillDownMenuMsgs(
    fn: (c: DrillDownMenuConfig) => Promise<DrillDownMenuResponse>
  ) {
    listener = fn;
  }

  async function show(
    config: DrillDownMenuConfig
  ): Promise<DrillDownMenuResponse> {
    const dispatcherEl = config.event.target as HTMLElement;
    if (
      dispatcherEl &&
      dispatcherEl.dataset &&
      dispatcherEl.dataset.ddtrigger === last_trigger_id
    ) {
      last_trigger_id = "";
      return { didUserSelectedAnAction: false };
    }
    last_trigger_id = Date.now() + "";
    dispatcherEl.setAttribute("data-ddTrigger", last_trigger_id);
    const res = await listener(config);
    setTimeout(() => {
      last_trigger_id = "";
    }, 0);
    return res;
  }

  return () => {
    return { show, listenForDrillDownMenuMsgs };
  };
})();
